import styled from "@emotion/native";

export const Container = styled.View({
	flex: 1,
	flexDirection: "row",
	alignItems: "center",
	justifyContent: "flex-start",
});

export const Circle = styled.View(
	{
		width: 20,
		height: 20,
		alignItems: "center",
		justifyContent: "center",
		borderRadius: 10,
		marginHorizontal: 10,
	},
	({ theme }: any) => {
		return {
			backgroundColor: theme.color.accent,
		};
	}
);
